import { useMemo } from 'react'
import { useLocation } from 'react-router'

export default function useQueryParam(name) {
    const location = useLocation()
    
    return useMemo(() => {
        return new URLSearchParams(location.search).get(name)
    }, [location.search, name])
}
